import {
  Button,
  makeStyles,
  mergeClasses,
  tokens,
  Tooltip,
} from "@fluentui/react-components";
import React from "react";
import { $sky10, $sky60 } from "../../../cssjs/colors";
import {
  GlobalFilterOptionsEnum,
  IFilterOptionsConfig,
} from "../../../enum/global-filter/GlobalFilterEnum";

export interface IFilterOptionButtonsProps {
  filterOptions: IFilterOptionsConfig[];
  selectedOption: string;
  filterChangeHandler: (id: string) => void;
}

const FilterOptionButtons: React.FC<IFilterOptionButtonsProps> = ({
  filterOptions = [],
  selectedOption,
  filterChangeHandler,
}) => {
  const classes = useStyles();

  const filterOptionsContent = filterOptions.map((button, index) => {
    const buttonContent = (
      <Button
        key={button.id}
        onClick={() => filterChangeHandler(button.id)}
        className={mergeClasses(
          classes.button,
          selectedOption === button.id ? classes.selectedButton : "",
          index === 0 ? classes.firstButton : "",
          index === filterOptions.length - 1 ? classes.lastButton : ""
        )}
      >
        {button.label}
      </Button>
    );

    if (button.id === GlobalFilterOptionsEnum.rolling) {
      return (
        <Tooltip
          key={button.id}
          withArrow
          content={{
            children: "Set Rolling hours based on current time",
            className: classes.tooltip,
          }}
          relationship="description"
        >
          {buttonContent}
        </Tooltip>
      );
    }
    return buttonContent;
  });

  return (
    <div className={classes.buttonGroup} data-testid="filter-option-buttons">
      {filterOptionsContent}
    </div>
  );
};

export default FilterOptionButtons;

const useStyles = makeStyles({
  buttonGroup: {
    display: "flex",
    borderRadius: "8px",
    color: $sky60,
  },
  button: {
    borderRadius: "0",
    color: $sky60,
    "&:hover": {
      backgroundColor: $sky10,
      color: $sky60,
    },
  },
  selectedButton: {
    backgroundColor: $sky60,
    color: "white",
    "&:hover": {
      backgroundColor: $sky60,
      color: "white",
    },
  },
  firstButton: {
    borderRadius: "8px 0 0 8px",
  },
  lastButton: {
    borderRadius: "0 8px 8px 0",
  },
  tooltip: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundInverted,
  },
});
